import { render, staticRenderFns } from "./purchase-request-list.vue?vue&type=template&id=4382ca5a&scoped=true&"
import script from "./purchase-request-list.vue?vue&type=script&lang=js&"
export * from "./purchase-request-list.vue?vue&type=script&lang=js&"
import style0 from "./purchase-request-list.vue?vue&type=style&index=0&id=4382ca5a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4382ca5a",
  null
  
)

export default component.exports